import React from 'react'
import ModalUI from '../layout/ModalUI'
import ButtonUI from '../action/ButtonUI'
import SpinnerUI from '../output/SpinnerUI'
import FileInputSF from '../input/FileInputSF'

const FileUploadModalUI = ({ context, fileInput, multiple,
  uploadMode, handleSubmit, submitted, onCancelClick, titleLabel,
  successMsg, errorList, setErrorList, hint,
  customFileName, onCustomFileNameChange
}) =>
  <ModalUI
    context={context}
    titleLabel={titleLabel || 'Upload file'}
    isOpen={uploadMode}
    onRequestClose={onCancelClick}
  >
    <form onSubmit={handleSubmit} className='g_flex_v'>
      {
        errorList && errorList.length > 0 && (
          <div className='g_error g_m_bottom_10'>
            {errorList.map((err, idx) => (
              <div key={idx}>{typeof err === 'string' ? err : err.message}</div>
            ))}
          </div>
        )
      }
         {
        multiple &&
        <input type='file' ref={fileInput} multiple />
      }
      {
        !multiple &&
        <input type='file' ref={fileInput} />
      }
      {
        onCustomFileNameChange &&
        <input type='text' placeholder='File name (optional)' className='g_m_top_50'
          value={customFileName || ''}
          onChange={(e) => onCustomFileNameChange(e.target.value)}
        />
      }
      {
        hint &&
        <div className='g_error'>{hint}</div>
      }
      <span className='g_flex_h g_m_top_50 g_flex_right'>
        <SpinnerUI show={submitted} className='g_m_right_50' />
        <ButtonUI label='Upload' />
      </span>
    </form>
  </ModalUI>

export default FileUploadModalUI